module.exports = __webpack_public_path__ + "img/smart-home@3x.354cb155.jpg";